/**
 * Configuration for pages that display sensitive financial data
 * 
 * Pages listed here will show the sensitive data toggle in the header.
 * Add new pages to this list when they contain financial information that
 * should be maskable (revenue, costs, margins, budgets, etc.)
 */
export const PAGES_WITH_SENSITIVE_DATA = [
  'dashboard',        // Homepage - Shows revenue, costs, and financial KPIs
  'projects',         // Displays budget revenue, actual revenue, costs, margins
  'project-details',  // Extensive financial data (budgets, actuals, variance, margins, WIP, unbilled)
  'portfolio',        // Shows financial metrics across portfolios
  'wip-reporting',    // Contains WIP amounts, unbilled amounts, and financial data
  // Future pages to add when implemented:
  // 'profitability',  // Will show profitability metrics when built
  // 'budgets',        // Will show budget data when built
] as const;

/**
 * Check if a page should display the sensitive data toggle
 */
export function shouldShowSensitiveDataToggle(currentPage: string): boolean {
  return PAGES_WITH_SENSITIVE_DATA.includes(currentPage as any);
}
